import { render, staticRenderFns } from "./PreSupportConfirmation.vue?vue&type=template&id=ab20f8bc&scoped=true"
import script from "./PreSupportConfirmation.vue?vue&type=script&lang=ts"
export * from "./PreSupportConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./PreSupportConfirmation.vue?vue&type=style&index=0&id=ab20f8bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab20f8bc",
  null
  
)

export default component.exports